var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_115_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.35 52.5C61.65 50.025 61.875 47.55 61.875 45C61.875 42.45 61.65 39.975 61.35 37.5H74.025C74.625 39.9 75 42.4125 75 45C75 47.5875 74.625 50.1 74.025 52.5M54.7125 73.35C56.9625 69.1875 58.6875 64.6875 59.8875 60H70.95C67.3169 66.256 61.5529 70.995 54.7125 73.35ZM53.775 52.5H36.225C35.85 50.025 35.625 47.55 35.625 45C35.625 42.45 35.85 39.9375 36.225 37.5H53.775C54.1125 39.9375 54.375 42.45 54.375 45C54.375 47.55 54.1125 50.025 53.775 52.5ZM45 74.85C41.8875 70.35 39.375 65.3625 37.8375 60H52.1625C50.625 65.3625 48.1125 70.35 45 74.85ZM30 30H19.05C22.6449 23.7264 28.405 18.9797 35.25 16.65C33 20.8125 31.3125 25.3125 30 30ZM19.05 60H30C31.3125 64.6875 33 69.1875 35.25 73.35C28.4185 70.9961 22.6661 66.2557 19.05 60ZM15.975 52.5C15.375 50.1 15 47.5875 15 45C15 42.4125 15.375 39.9 15.975 37.5H28.65C28.35 39.975 28.125 42.45 28.125 45C28.125 47.55 28.35 50.025 28.65 52.5M45 15.1125C48.1125 19.6125 50.625 24.6375 52.1625 30H37.8375C39.375 24.6375 41.8875 19.6125 45 15.1125ZM70.95 30H59.8875C58.712 25.356 56.9742 20.8729 54.7125 16.65C61.6125 19.0125 67.35 23.775 70.95 30ZM45 7.5C24.2625 7.5 7.5 24.375 7.5 45C7.5 54.9456 11.4509 64.4839 18.4835 71.5165C21.9657 74.9987 26.0997 77.7609 30.6494 79.6455C35.1991 81.53 40.0754 82.5 45 82.5C54.9456 82.5 64.4839 78.5491 71.5165 71.5165C78.5491 64.4839 82.5 54.9456 82.5 45C82.5 40.0754 81.53 35.1991 79.6455 30.6494C77.7609 26.0997 74.9987 21.9657 71.5165 18.4835C68.0343 15.0013 63.9003 12.2391 59.3506 10.3545C54.8009 8.46997 49.9246 7.5 45 7.5Z",
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_115_112",
    x: -4,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_115_112",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.6d60e0ca0645affda9f663be87cb0bde.svg";
export { ForwardRef as ReactComponent };